module.exports = __webpack_public_path__ + "static/media/Blo.bd439110.pdf";